import { AutocompleteUserResultFilter } from '@ms/yammer-graphql';

import { Group, TypeaheadResults } from '../../state/types';

interface GetIdParams {
  readonly search: string;
  readonly type: keyof TypeaheadResults;
  readonly isFilteringResults?: boolean;
  readonly groupIds?: Group['id'][];
  readonly userResultFilter?: AutocompleteUserResultFilter;
}

type GetId = (parameters: GetIdParams) => string;
export const getId: GetId = ({ search, type, isFilteringResults, groupIds, userResultFilter }) => {
  switch (type) {
    case 'groups':
      return `${type}-${search.toLowerCase()}-onlyGroupsWhereViewerCanPost:${isFilteringResults ?? 'false'}`;
    case 'users':
      return `${type}-${search.toLowerCase()}-groupIds:${groupIds}-excludeExternalUsers:${
        isFilteringResults ?? 'false'
      }-userResultFilter:${userResultFilter}`;
    default:
      return `${type}-${search.toLowerCase()}`;
  }
};
